import { CircularProgress } from '@material-ui/core';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateCustomerSource } from '../../store/Checkout/actions';
import { customerGroup } from '../../store/PostActivation/actions';
import ButtonNew from '../Button/Button';
import TextField from '../Textfield/TextField';
import './AddLineUserDetails.scss';
import successIcon from '../../Assets/images/Activation/success.svg';

type initialProps = {
    history: any;
    userData: any;
    changeCurrentPage?: any;
    isEditName?: boolean;
    setIsEditName?: any;
};

const AddLineUserDetails = (props: initialProps) => {
    const { userData, changeCurrentPage, isEditName, setIsEditName } = props;
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
    });
    const [loader, setLoader] = useState(false);
    const [nameUpdated, setNameUpdated] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { checkout } = useSelector((state: any) => state);

    useEffect(() => {
        setFormData({
            ...formData,
            firstName: userData?.firstName?.toUpperCase(),
            lastName: userData?.lastName?.toUpperCase(),
        });
    }, []);

    const initialRender1 = useRef(true);
    useEffect(() => {
        if (initialRender1.current === true) {
            initialRender1.current = false;
        } else {
            const updateCustomer = checkout.updateCustomerSource;
            if (isEditName) {
                if (updateCustomer && updateCustomer.status === 'SUCCESS' && updateCustomer.data) {
                    setNameUpdated(true);
                    setLoader(false);
                }
            } else {
                if (updateCustomer && updateCustomer.status === 'SUCCESS' && updateCustomer.data) {
                    localStorage.setItem('secondaryCustomerDetail', JSON.stringify(updateCustomer.data));
                    dispatch(customerGroup({ groupId: userData && userData.groupId }));
                    setLoader(false);
                    changeCurrentPage('MainPage');
                    setNameUpdated(true);
                }
            }
        }
    }, [checkout.updateCustomerSource]);

    const onChangeHandler = (e: any, type: any) => {
        const value = e.target.value.replace(/\s+/g, ' ');
        if (type === 'firstName') {
            if (e.target.value === ' ' && formData?.firstName.length === 0) {
                return;
            }
            setFormData({ ...formData, firstName: value.trimStart() });
        } else if (type === 'lastName') {
            if (e.target.value === ' ' && formData?.lastName.length === 0) {
                return;
            }
            setFormData({ ...formData, lastName: value.trimStart() });
        }
    };

    const updateCustomerHandler = () => {
        setLoader(true);
        isEditName
            ? dispatch(
                  UpdateCustomerSource({
                      customerId: userData?.id,
                      data: {
                          firstName: formData?.firstName?.toUpperCase(),
                          lastName: formData?.lastName?.toUpperCase(),
                      },
                  }),
              )
            : dispatch(
                  UpdateCustomerSource({
                      customerId: userData?.id,
                      data: {
                          firstName: formData?.firstName?.toUpperCase(),
                          lastName: formData?.lastName?.toUpperCase(),
                          activationJourneyStatus: 'IN_PROGRESS',
                      },
                  }),
              );
    };

    return (
        <>
            {isEditName && !nameUpdated && <div className="editUserHeading">Edit Name</div>}
            {!nameUpdated && (
                <div className="line3-user-details">
                    <div className="InputField">
                        <div className="imeiText">FIRST NAME</div>
                        <TextField
                            value={formData?.firstName}
                            type="text"
                            onChange={(e: any) => {
                                if (
                                    /^[a-zA-Z0-9 ~`!@#$%^&*()_+={}\[\]|\\:;"'<>,.?/-]+$/.test(e.target.value) ||
                                    e.target.value === ''
                                ) {
                                    onChangeHandler(e, 'firstName');
                                }
                            }}
                            maxlength={32}
                        />
                        <div className="errorMessage">
                            {formData?.firstName === ''
                                ? 'First name is required'
                                : formData?.firstName !== '' &&
                                  formData?.firstName?.length > 1 &&
                                  ((formData?.firstName[1] === ' ' && formData?.firstName?.length === 2) ||
                                      formData?.firstName?.length < 2)
                                ? 'First name must be 2 to 32 characters long'
                                : ''}
                        </div>
                    </div>
                    <div className="InputField">
                        <div className="imeiText">LAST NAME</div>
                        <TextField
                            value={formData?.lastName}
                            type="text"
                            onChange={(e: any) => {
                                if (
                                    /^[a-zA-Z0-9 ~`!@#$%^&*()_+={}\[\]|\\:;"'<>,.?/-]+$/.test(e.target.value) ||
                                    e.target.value === ''
                                ) {
                                    onChangeHandler(e, 'lastName');
                                }
                            }}
                            maxlength={32}
                        />
                        <div className="errorMessage">
                            {formData?.lastName === ''
                                ? 'Last name is required'
                                : formData?.lastName !== '' &&
                                  formData?.lastName?.length > 1 &&
                                  ((formData?.lastName[1] === ' ' && formData?.lastName?.length === 2) ||
                                      formData?.lastName?.length < 2)
                                ? 'Last name must be 2 to 32 characters long'
                                : ''}
                        </div>
                    </div>
                    <div className="conti-to-acti">
                        <ButtonNew
                            primary={true}
                            onClick={!loader ? updateCustomerHandler : () => {}}
                            disabled={
                                !formData?.firstName ||
                                !formData?.lastName ||
                                (formData?.firstName[1] === ' ' && formData?.firstName?.length === 2) ||
                                (formData?.lastName[1] === ' ' && formData?.lastName?.length === 2) ||
                                formData?.firstName?.length < 2 ||
                                formData?.lastName?.length < 2
                            }
                        >
                            {loader ? (
                                <div className="loaderCheck text-center">
                                    <CircularProgress />
                                </div>
                            ) : (
                                `${isEditName ? 'SAVE' : 'CONTINUE TO ACTIVATION'}`
                            )}
                        </ButtonNew>
                    </div>
                </div>
            )}
            {isEditName && nameUpdated && (
                <div className="activationStatus">
                    <img src={successIcon} />
                    <div className="activationStatusTitle" style={{ marginBottom: '40px' }}>
                        Username has been updated!
                    </div>
                    <ButtonNew primary={true} onClick={() => setIsEditName(false)}>
                        BACK TO HOME
                    </ButtonNew>
                </div>
            )}
        </>
    );
};

export default AddLineUserDetails;
